__turbopack_context__.v({
  "inner": "SidebarNav-module-scss-module__ZBnn5G__inner",
  "scrollArea": "SidebarNav-module-scss-module__ZBnn5G__scrollArea",
  "sidebar": "SidebarNav-module-scss-module__ZBnn5G__sidebar",
});
